import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="footer-grid">
          <div>
            <div className="fb-logo"><div className="fb-logo-dot" />MIG</div>
            <div className="fb-desc">
              Market Intelligence Grid — AI-powered daily research intelligence for public companies.
              Built for accountability, not hype.
            </div>
          </div>
          <div className="fc">
            <div className="fc-title">Product</div>
            <Link to="/register?plan=free">Free account</Link>
            <Link to="/register?plan=monthly">Pro Monthly</Link>
            <Link to="/register?plan=annual">Pro Annual</Link>
            <a href="#features">Features</a>
          </div>
          <div className="fc">
            <div className="fc-title">Platform</div>
            <a href="#research">Daily Research</a>
            <a href="#projections">Projections</a>
            <a href="#track">Track Record</a>
            <a href="#plans">Pricing</a>
          </div>
          <div className="fc">
            <div className="fc-title">Legal</div>
            <a href="#">Terms of Service</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Disclaimer</a>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 Market Intelligence Grid. All rights reserved.</span>
          <span>General market research — not financial advice.</span>
        </div>
      </footer>
      <div className="disclaimer">
        Market Intelligence Grid publishes general market research for informational purposes only. Nothing published constitutes personalized financial advice,
        a solicitation to buy or sell any security, or a guarantee of any specific outcome. Past projection accuracy is not indicative of future results.
        All claims are labeled fact / strong_inference / weak_inference / speculation. Please read our full{' '}
        <a href="#" style={{ color: 'var(--blue)' }}>disclaimer</a> before acting on any content.
      </div>
    </>
  );
}
